import React from 'react'
import styled from 'styled-components'
import { Box, Flex } from 'pcln-design-system'
import ReasonsToBelieveTile from './ReasonsToBelieveTile'
import { Banner } from './types'

const StyledFlex = styled(Flex)`
  max-width: 1280px;
`

const ReasonsToBelieveBanner = ({
  backgroundColor = 'background.light',
  content,
  headingFontColor = 'text.base',
  iconColor = 'primary',
  subtextFontColor = 'text.light'
}: Banner) => {
  const tileCount = content.length

  return (
    <Box color={backgroundColor}>
      <StyledFlex
        color={backgroundColor}
        justifyContent="space-around"
        mx="auto"
        p={3}
        tileCount={tileCount}
      >
        {content &&
          content.map(tileContent => (
            <ReasonsToBelieveTile
              href={tileContent.href}
              key={tileContent.iconName}
              headingFontColor={headingFontColor}
              iconColor={iconColor}
              subtextFontColor={subtextFontColor}
              tileContent={tileContent}
              tileCount={tileCount}
            />
          ))}
      </StyledFlex>
    </Box>
  )
}

export default ReasonsToBelieveBanner
